import GeneralInspection from "./GeneralInspection";
export default GeneralInspection;
